import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
	selector: 'app-signatures',
	templateUrl: './signatures.component.html',
	styleUrls: ['./signatures.component.css']
})
export class SignaturesComponent implements OnInit {
	authError = false;
	authMessage;

	error = false;

	loadingProcoreDetails = true;
	loadingSignatures = true;
	loadingProjects = true;
	loadingProjectNames = true;
	loadingDownloadIds = [];
	loadingSendMassReminders = false;
	loadingSendReminderIds = [];

	initialResultsLoaded = false;

	sendReminderIdsSuccess = [];
	sendReminderIdsFail404 = [];
	sendReminderIdsFail410 = [];

	downloadIdsFail = [];

	showSendReminderButton = false;

	clientDetailProcore: any;

	signatures = [];
	signaturesCount = 0;
	projects = [];

	startPosition = 0;

	liveSignaturesCount = 0;
	testSignaturesCount = 0;

	uuid;
	companyId;
	email;
	procoreUserId;
	procoreIsSandbox;

	showStatusSelector = false;
	showModeSelector = false;
	showProjectSelector = false;
	filterStatus = 'ALL';
	filterMode = 'ALL';
	filterProject = 'ALL';
	filterProjectName = '';
	sortBy = 'signatureRequestDate';
	sortOrder = 'desc';

	constructor(
		private dashboardService: DashboardService,
		private route: ActivatedRoute
	) { }

	ngOnInit() {
		console.log('ngOnInit');
		this.loadQueryParams();
	}

	loadQueryParams() {
		console.log('loadQueryParams');
		this.route.queryParams.subscribe(params => {
			if (params['uuid']) {
				this.uuid = params['uuid'];
				console.log(this.uuid);

				this.getDashboardProcoreDetails();
			} else {
				console.log('no uuid');

				this.error = true;
			}
		});
	}

	getDashboardProcoreDetails() {
		this.loadingProcoreDetails = true;
		this.dashboardService.getDashboardClientDetailProcore(this.uuid).subscribe((clientDetailProcore: any) => {
			console.log(clientDetailProcore);

			this.clientDetailProcore = clientDetailProcore;
			this.uuid = clientDetailProcore.uuid;

			this.loadingProcoreDetails = false;

			this.getDashboardProjects();
		}, err => {
			this.error = true;
		});
	}

	getDashboardProjects() {
		this.loadingProjects = true;
		this.dashboardService.getDashboardProjects(this.uuid).subscribe((response: any) => {
			console.log(response);

			this.uuid = response.uuid;
			this.projects = response.projects;

			this.loadingProjects = false;

			this.getDashboardSignatures();
		}, err => {
			this.error = true;
		});
	}

	reloadSignatures() {
		this.signatures = [];
		this.startPosition = 0;
		this.liveSignaturesCount = 0;
		this.testSignaturesCount = 0;
		this.showSendReminderButton = false;
		this.initialResultsLoaded = false; // test this

		this.getDashboardSignatures();
	}

	getDashboardSignatures() {
		this.loadingSignatures = true;
		this.dashboardService.getDashboardSignatures(this.uuid, this.startPosition, this.filterStatus, this.filterProject, this.filterMode, this.sortBy, this.sortOrder).subscribe((response: any) => {
			this.uuid = response.uuid;
			this.signaturesCount = response.signaturesCount;

			for (let i = 0; i < response.signatures.length; i++) {


				// Show send all reminders button if at least one status is REQUESTED
				if (response.signatures[i].status == 'REQUESTED') {
					this.showSendReminderButton = true;
				}

				// Increase the signature counts
				if (response.signatures[i].isProductionMode) {
					this.liveSignaturesCount++;
				} else {
					this.testSignaturesCount++;
				}

				// Translate the project name
				if (response.signatures[i].projectId) {
					let item = this.projects.find(d => d.id == response.signatures[i].projectId);
					if (item) {
						response.signatures[i].projectName = item.name;
					}
				}

				this.signatures.push(response.signatures[i]);

				this.startPosition++;
			}

			this.initialResultsLoaded = true;
			this.loadingSignatures = false;
		}, err => {
			this.error = true;
		});
	}

	setSortBy(sortBy) {
		if (sortBy == this.sortBy) {
			// It's the same, change sort order
			if (this.sortOrder == 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc'
			}
		} else {
			// It's different, change sort by
			this.sortBy = sortBy;
		}

		this.reloadSignatures();
	}

	sendReminder(signature) {
		this.loadingSendReminderIds.push(signature.signatureRequestId);
		console.log(signature);

		this.dashboardService.getDashboardReminderEmail(this.uuid, signature.signatureRequestId)
			.subscribe(
				(response: any) => {
					this.uuid = response.uuid;

					console.log('getDashboardReminderEmail response');
					console.log(response);

					if (response.errorMessage == 'Not found') {
						let item = this.loadingSendReminderIds.find(d => d === signature.signatureRequestId);
						this.sendReminderIdsFail404.push(item);

						this.loadingSendReminderIds.splice(this.loadingSendReminderIds.indexOf(item), 1);
					} else {
						this.dashboardService.sendDashboardReminder(this.uuid, signature.signatureRequestId, response.email)
							.subscribe(
								(responseInner: any) => {
									console.log('sendDashboardReminder responseInner');
									console.log(responseInner);

									this.uuid = responseInner.uuid;

									let item = this.loadingSendReminderIds.find(d => d === signature.signatureRequestId);

									if (responseInner.reminderMessage == 'A reminder has been sent.') {
										this.sendReminderIdsSuccess.push(item);
									} else {
										this.sendReminderIdsFail410.push(item);
									}

									this.loadingSendReminderIds.splice(this.loadingSendReminderIds.indexOf(item), 1);
								},
								err => {
									console.log('sendDashboardReminder err');
									console.log(err);
									this.error = true;
								});
					}
				},
				err => {
					console.log('getDashboardReminderEmail err');
					console.log(err);
					this.error = true;
				});
	}


	sendMassReminders() {
		this.loadingSendMassReminders = true;
		this.sendReminderIdsSuccess = [];
		this.sendReminderIdsFail410 = [];
		this.sendReminderIdsFail404 = [];

		let i = 0;
		let _this = this;

		(function repeat() {
			// Ensure the status is REQUESTED
			if (_this.signatures[i].status == 'REQUESTED') {
				// Ensure the request is part of the current project filter
				if (_this.filterProject == 'ALL' || _this.signatures[i].projectId == _this.filterProject) {
					// Ensure the request is part of the current production mode filter
					if (_this.filterMode == 'ALL' || _this.signatures[i].isProductionMode.toString() === _this.filterMode) {
						console.log('sendMassReminders ' + i);

						_this.loadingSendReminderIds.push(_this.signatures[i].signatureRequestId);
						console.log(_this.signatures[i]);

						_this.dashboardService.getDashboardReminderEmail(_this.uuid, _this.signatures[i].signatureRequestId)
							.subscribe((response: any) => {

								_this.uuid = response.uuid;

								if (response.errorMessage == 'Not found') {
									let item = _this.loadingSendReminderIds.find(d => d === _this.signatures[i].signatureRequestId);
									_this.sendReminderIdsFail404.push(item);

									_this.loadingSendReminderIds.splice(_this.loadingSendReminderIds.indexOf(item), 1);

									// INCREMENT
									// Determine if this is the last loop
									if (i == _this.signatures.length - 1) {
										_this.loadingSendMassReminders = false;
									} else {
										i++;

										setTimeout(function () {
											repeat();
										}, 1000);
									}
								} else {
									_this.dashboardService.sendDashboardReminder(_this.uuid, _this.signatures[i].signatureRequestId, response.email)
										.subscribe(
											(responseInner: any) => {

												_this.uuid = responseInner.uuid;

												let item = _this.loadingSendReminderIds.find(d => d === _this.signatures[i].signatureRequestId);

												if (responseInner.reminderMessage == 'A reminder has been sent.') {
													_this.sendReminderIdsSuccess.push(item);
												} else {
													_this.sendReminderIdsFail410.push(item);
												}

												_this.loadingSendReminderIds.splice(_this.loadingSendReminderIds.indexOf(item), 1);

												// INCREMENT
												// Determine if this is the last loop
												if (i == _this.signatures.length - 1) {
													_this.loadingSendMassReminders = false;
												} else {
													i++;

													setTimeout(function () {
														repeat();
													}, 1000);
												}
											},
											err => {
												_this.error = true;

												// INCREMENT
												// Determine if this is the last loop
												if (i == _this.signatures.length - 1) {
													_this.loadingSendMassReminders = false;
												} else {
													i++;

													setTimeout(function () {
														repeat();
													}, 1000);
												}
											});
								}
							}, err => {
								// INCREMENT
								// Determine if this is the last loop
								if (i == _this.signatures.length - 1) {
									_this.loadingSendMassReminders = false;
								} else {
									i++;

									setTimeout(function () {
										repeat();
									}, 1000);
								}
							});
					} else {
						// INCREMENT
						// Determine if this is the last loop
						if (i == _this.signatures.length - 1) {
							_this.loadingSendMassReminders = false;
						} else {
							i++;
							repeat();
						}
					}
				} else {
					// INCREMENT
					// Determine if this is the last loop
					if (i == _this.signatures.length - 1) {
						_this.loadingSendMassReminders = false;
					} else {
						i++;
						repeat();
					}
				}
			} else {
				// INCREMENT
				// Determine if this is the last loop
				if (i == _this.signatures.length - 1) {
					_this.loadingSendMassReminders = false;
				} else {
					i++;
					repeat();
				}
			}
		})();
	}

	downloadRequest(signatureRequestId, filename) {
		this.loadingDownloadIds.push(signatureRequestId);
		this.dashboardService.getDashboardSignatureDownloadStream(this.uuid, signatureRequestId, filename)
			.subscribe((result) => {
				saveAs(result, filename);

				let item = this.loadingDownloadIds.find(d => d === signatureRequestId);
				if (item) {
					this.loadingDownloadIds.splice(this.loadingDownloadIds.indexOf(item), 1);
				}


			}, (error) => {
				// Move from the loading to the error array
				let item = this.loadingDownloadIds.find(d => d === signatureRequestId);
				if (item) {
					this.downloadIdsFail.push(item);
					this.loadingDownloadIds.splice(this.loadingDownloadIds.indexOf(item), 1);
				}
			});
	}

	checkLoadingDownload(signatureRequestId) {
		let item = this.loadingDownloadIds.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}

	checkErrorDownload(signatureRequestId) {
		let item = this.downloadIdsFail.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}

	checkLoadingSenderReminder(signatureRequestId) {
		let item = this.loadingSendReminderIds.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}

	checkErrorSenderReminder404(signatureRequestId) {
		let item = this.sendReminderIdsFail404.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}

	checkErrorSenderReminder410(signatureRequestId) {
		let item = this.sendReminderIdsFail410.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}

	checkSuccessSenderReminder(signatureRequestId) {
		let item = this.sendReminderIdsSuccess.find(d => d === signatureRequestId);
		if (item) {
			return true;
		} else {
			return false;
		}
	}
}
